import CryptoJS from "crypto-js";

const secretKey = "st@rbus5";
export const encryptData = (data) => {
    const cipherText = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
    return cipherText.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};
export const decryptData = (cipherText) => {
    const base64CipherText = cipherText.replace(/-/g, '+').replace(/_/g, '/');
    const bytes = CryptoJS.AES.decrypt(base64CipherText, secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};